import { FC } from 'react';
import { StyledRfpCard } from './RfpCard.styles';
import { RfpCardProps } from './RfpCard.types';
import { Image, Button } from '@marriott/mi-ui-library';

export const RfpCard: FC<RfpCardProps> = ({
  item,
  index,
  labels,
  isSearchResults,
  canRemove,
  onRemove,
  onUndoRemove,
}) => {
  const { basicInformation, image, isMarkForRemoved } = item;
  const { property, optional, removeAriaLabel, undoProperty } = labels;

  return (
    <StyledRfpCard>
      {basicInformation?.name ? (
        <div className="card-container">
          <div role="img" tabIndex={0} aria-label={`${basicInformation.name} ${image?.altText}`}>
            <Image
              title=""
              defaultImageURL={`${image?.defaultImageUrl}`}
              altText={image?.altText}
              customClass="card-image"
            />
          </div>
          {isSearchResults || (!isSearchResults && canRemove && !isMarkForRemoved) ? (
            <Button
              className={'icon-clear remove-card'}
              ariaLabel={`${removeAriaLabel?.replace('{name}', basicInformation.name)}`}
              callback={() => onRemove(item.id)}
            />
          ) : null}
          <div className="card-title">{basicInformation.name}</div>
          {!isSearchResults && isMarkForRemoved ? (
            <div className="undo-layer">
              <Button ariaLabel={`${undoProperty} ${basicInformation.name}`} callback={() => onUndoRemove(item.id)}>
                {undoProperty}
              </Button>
            </div>
          ) : null}
        </div>
      ) : isSearchResults ? (
        <div className="card-shell d-flex justify-content-center align-items-center flex-column">
          <span className="shell-title">{`${property} ${index + 1}`}</span>
          <span className="shell-subtitle">{optional}</span>
        </div>
      ) : null}
    </StyledRfpCard>
  );
};
